import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { ProtectedRoute } from './components/ProtectedRoute';
import { DashboardLayout } from './components/DashboardLayout';
import { AtmosphereProvider } from './components/Atmosphere';
import { LoginPage } from './pages/LoginPage';
import { RegisterPage } from './pages/RegisterPage';
import { DashboardPage } from './pages/DashboardPage';
import { CeremoniesPage } from './pages/CeremoniesPage';
import { TasksPage } from './pages/TasksPage';
import { BudgetPage } from './pages/BudgetPage';
import { VendorsPage } from './pages/VendorsPage';
import { GuestsPage } from './pages/GuestsPage';
import { CommandCenterPage } from './pages/CommandCenterPage';
import { CheckinPage } from './pages/CheckinPage';
import { PaymentsPage } from './pages/PaymentsPage';
import { ExpensesPage } from './pages/ExpensesPage';
import { Toaster } from './components/ui/sonner';
import './App.css';

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route
            path="/login"
            element={
              <AtmosphereProvider mode="auth">
                <LoginPage />
              </AtmosphereProvider>
            }
          />
          <Route
            path="/register"
            element={
              <AtmosphereProvider mode="auth">
                <RegisterPage />
              </AtmosphereProvider>
            }
          />
          <Route path="/checkin/:guestId" element={<CheckinPage />} />
          <Route
            path="/"
            element={
              <ProtectedRoute>
                <AtmosphereProvider mode="app">
                  <DashboardLayout />
                </AtmosphereProvider>
              </ProtectedRoute>
            }
          >
            <Route index element={<Navigate to="/dashboard" replace />} />
            <Route path="dashboard" element={<DashboardPage />} />
            <Route path="command-center" element={<CommandCenterPage />} />
            <Route path="ceremonies" element={<CeremoniesPage />} />
            <Route path="tasks" element={<TasksPage />} />
            <Route path="budget" element={<BudgetPage />} />
            <Route path="vendors" element={<VendorsPage />} />
            <Route path="payments" element={<PaymentsPage />} />
            <Route path="expenses" element={<ExpensesPage />} />
            <Route path="guests" element={<GuestsPage />} />
          </Route>
        </Routes>
      </BrowserRouter>
      <Toaster position="bottom-right" />
    </AuthProvider>
  );
}

export default App;
